import Text from '../../../../Text'
import { getMatchCoverageText } from '../../RentalPortalMatch.utils'
import { RentalPortalMatchEligibilityBadge } from '../../RentalPortalMatchEligibilityBadge'

import * as styles from './RentalPortalMatchCriteriaPopoverHeader.module.css'

function RentalPortalMatchCriteriaPopoverHeader({ match }) {
  return (
    <div className={styles.RentalPortalMatchCriteriaPopoverHeader}>
      <RentalPortalMatchEligibilityBadge
        className={styles.badge}
        match={match}
      />
      <Text isSecondary className={styles.coverage}>
        {getMatchCoverageText(match)}
      </Text>
    </div>
  )
}

export default RentalPortalMatchCriteriaPopoverHeader
